module.exports = __webpack_public_path__ + "202408221624/img/home_case_5.543af8f0.jpg";